import { Box, styled } from '@mui/material';
import { routePath } from '~/utils/constants';
import AdminLoginBgImg from '/assets/image/admin_login_bg.svg';

type TStyledBackground = {
  pathname: string;
};

export const StyleBackground = styled(Box, {
  shouldForwardProp: prop => prop !== 'pathname',
})<TStyledBackground>(({ theme, pathname }) => {
  let background;
  switch (pathname) {
    case routePath.admin:
    case routePath.latestNews:
      background = theme.palette.grey[200];
      break;
    case routePath.adminLogin:
      background = `center / cover no-repeat ${theme.palette.info.darker} url(${AdminLoginBgImg})`;
      break;
    default:
      background = theme.palette.primary.contrastText;
  }
  return {
    background,
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: '0px',
    zIndex: '-1',
  };
});
